module.exports = __webpack_public_path__ + "img/logo.f616e33d.jpg";